import { FormattedMessage, useIntl } from 'react-intl';

import styles from '@components/ActivityStage.module.css';
import { CareProfileStageLimitedEnum } from '@typing/Generated';

type Props = {
  stage: CareProfileStageLimitedEnum | null;
  type: string;
};

const ActivityStage = ({ stage, type }: Props) => {
  const intl = useIntl();

  if (stage) {
    return (
      <div className={styles.stage}>
        <div className={styles.stageTitle}>
          <FormattedMessage id={`models.initialConsultReport.questions.stages.types.${type}`} />
        </div>
        <div>{intl.formatMessage({ id: `models.journey.stage.${stage}` })}</div>
      </div>
    );
  }
  return null;
};

export default ActivityStage;
